// A select of countries from @convenor/shared, with "Not given" first (UI.md 8).
import { COUNTRIES, GENDERS, GENDER_LABELS, STAKEHOLDER_TYPES, STAKEHOLDER_TYPE_LABELS } from "@convenor/shared";
import { SelectField } from "./Field";
import type { ComponentProps } from "react";

type SelectProps = Omit<ComponentProps<typeof SelectField>, "options">;

export const COUNTRY_OPTIONS = COUNTRIES.map((c) => ({ value: c.code, label: c.name }));

export function CountrySelect({ emptyLabel = "Not given", ...props }: SelectProps & { emptyLabel?: string }) {
  return <SelectField {...props} options={[{ value: "", label: emptyLabel }, ...COUNTRY_OPTIONS]} />;
}

export function GenderSelect({ emptyLabel = "Not given", ...props }: SelectProps & { emptyLabel?: string }) {
  return (
    <SelectField
      {...props}
      options={[{ value: "", label: emptyLabel }, ...GENDERS.map((g) => ({ value: g, label: GENDER_LABELS[g] }))]}
    />
  );
}

export function StakeholderTypeSelect({ emptyLabel = "Not given", ...props }: SelectProps & { emptyLabel?: string }) {
  return (
    <SelectField
      {...props}
      options={[
        { value: "", label: emptyLabel },
        ...STAKEHOLDER_TYPES.map((t) => ({ value: t, label: STAKEHOLDER_TYPE_LABELS[t] })),
      ]}
    />
  );
}
